export default {
  'Difficulty level': '難度級別',
  'Your bet': '賭注',
  'Start game': '開始遊戲',
  'Take prize': '拿',
  'Try again': '再試一次',
  Bet: '賭注',
  Profit: '收益',
};
